/* eslint-disable jsx-a11y/anchor-is-valid */

import UseLogin from 'app/modules/core/hooks/users/UseLogin'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { KPISummaryService, LeaderBoardDto, SeasonDto, SeasonService, TableDto } from 'app/modules/core'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'

const LeaderBoardPage: FC = () => {
  const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
  const [data, setData] = useState<LeaderBoardDto>()
  const [season, setSeason] = useState<SeasonDto[]>()
  const [selectedSeason, setSelectedSeason] = useState<number|undefined>(lastSeason?.id)

  useMemo(() => {
    SeasonService.GetActiveSeasons().then(res => {
      setSeason(res.data.result)
    })
  }, [])

  useEffect(() => {
    const init = () => {
      if (lastSeason && lastSeason.id) {
        KPISummaryService.GetLeaderBoard(lastSeason.id).then(res => {
        
          setData(res.data.result)
        })
      }
    }
    init()
  }, [lastSeason?.id])

  const onSelectSeason = useCallback((seasonid: number) => {
    setSelectedSeason(seasonid)
    const init = () => {
      KPISummaryService.GetLeaderBoard(seasonid).then(res => {
        setData(res.data.result)
      })
    }
    init()
  }, [])



  return (
    <>
      <PageTitle breadcrumbs={[]}></PageTitle>
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8 justify-content-center'>
        <div className='card cursor-pointer'>
          <div className='card-header cursor-pointer'>
            <div className='card-title m-0 d-flex flex-column'>

              <h3 className='fw-bolder p-5 d-flex justify-content-between'><span className='pe-5'>เลือก Season</span> <span>
                <select className='form-control select' onChange={(e) =>
                  e.target?.value && onSelectSeason(Number(e.target.value))}
                  value={selectedSeason} >
                  {season?.map((item, index) => {
                    return <option key={index} value={item.id}>{item.title}</option>
                  })}
                </select>
              </span></h3>
            </div>
          </div>
          <div className='card-body p-9'><div className="d-flex flex-column mb-3">
            <div className="d-flex justify-content-center"><h2 >All time high</h2></div>
            <div className="d-flex justify-content-center">{`1.----${data?.allTimeHigh[1] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`2.----${data?.allTimeHigh[2] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`3.----${data?.allTimeHigh[3] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center"><h3>Full time rank</h3></div>
            <div className="d-flex justify-content-center">{`1.----${data?.fullTimeRank[1] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`2.----${data?.fullTimeRank[2] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`3.----${data?.fullTimeRank[3] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center"><h3>Part time rank</h3></div>
            <div className="d-flex justify-content-center">{`1.----${data?.partTimeRank[1] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`2.----${data?.partTimeRank[2] ?? 0} Points`} </div>
            <div className="d-flex justify-content-center">{`3.----${data?.partTimeRank[3] ?? 0} Points`} </div>

            {/* {data && renderItems(data)} */}

          </div></div>
        </div>

      </div>
      {/* end::Row */}
    </>
  )
}
export { LeaderBoardPage }
